import { createAction } from '@reduxjs/toolkit';
import { HomeResponse } from 'api/home';
import { Task } from 'api/tasks';

export const saveCompanyTasksSagaAction = createAction<Task[]>(
  'home/saveCompanyTasksSagaAction',
);
export const saveHomeResponseSagaAction = createAction<HomeResponse>(
  'home/saveHomeResponseSagaAction',
);
